import {useMemo} from 'react';

import {Box, Typography} from '@mui/material';
import './Mobile.scss';
import {useTranslation} from 'react-i18next';

import FuseSvgIcon from '@/@fuse/core/FuseSvgIcon';

interface PaymentLinkFeesItemProps {
  icon: React.ReactNode;
  title: string;
  flat_fee: number;
  percentage_fee?: number;
  onPress?: () => void;
  disable?: boolean;
}

const PaymentLinkFeesItem: React.FC<PaymentLinkFeesItemProps> = ({
  icon,
  title,
  flat_fee,
  percentage_fee,
  onPress,
  disable = false,
}) => {
  const {t} = useTranslation();
  const feeText = useMemo(() => {
    const instantText = t('payment_link.instant');

    const showFlatFee = flat_fee && flat_fee > 0;
    const showPercentageFee = percentage_fee && percentage_fee > 0;

    if (showFlatFee && showPercentageFee) {
      return `${instantText} - $${flat_fee.toFixed(2)} + ${percentage_fee}% network fees`;
    }

    if (showFlatFee) {
      return `${instantText} - $${flat_fee.toFixed(2)} fee`;
    }

    if (showPercentageFee) {
      return `${instantText} - ${percentage_fee}% network fees`;
    }

    return instantText;
  }, [flat_fee, percentage_fee, t]);

  return (
    <Box
      className={`payment-link-fees-item-container ${disable ? 'payment-link-fees-item-container-disabled' : ''}`}
      onClick={() => (disable ? null : onPress())}>
      <Box className="payment-link-fees-item-icon">{icon}</Box>
      <Box className="payment-link-fees-item-content">
        <Typography className="payment-link-fees-item-title">
          {title}
        </Typography>
        <Typography className="payment-link-fees-item-fee">
          {feeText}
        </Typography>
      </Box>
      <Box className="payment-link-fees-item-arrow">
        <FuseSvgIcon className="card-label-icon">
          heroicons-outline:chevron-right
        </FuseSvgIcon>
      </Box>
    </Box>
  );
};

export default PaymentLinkFeesItem;
